/* eslint-disable react/prop-types */
import React from 'react';
import images from '../../assets/images';
import RoundPhoto from '../../components/roundPhoto/RoundPhoto';
import styles from './organization.module.css';

const Organization = ({ org, handleSubmit }) => {
    return (
        <div className={styles.wrapperLi} key={org.id}>
            <li key={org.id}>
                <button
                    key={org.id}
                    onClick={() => handleSubmit(org)}
                    className={styles.camfire}>
                    <div className={styles.wrapperCamfire}>
                        <RoundPhoto
                            src={org.logoPicture || images.campfireSocialLogo}
                            alt={org.name}
                            borderEnable
                        />
                        {org.name}
                    </div>
                    <div className={styles.circle}>
                        <span key={org.id}>&#10132;</span>
                    </div>
                </button>
            </li>
        </div>
    );
};

export default Organization;
